import { breadcrumbConstantService } from './breadcrumbsConstantService';

/**
 * @typedef {Object} BreadcrumbItem
 * @property {string} name
 * @property {string} path
 */

/**
 * @typedef {Object} ModuleObj
 * @property {string} [route]
 * @property {*} [key]
 */

export const breadCrumbUtilService = () => {
    /**
     * @param {Object.<string, ModuleObj>} routeStructureObj
     * @returns {Object.<string, BreadcrumbItem[]|Object.<string, BreadcrumbItem[]>>}
     */
    function createRouteMappings(routeStructureObj) {
        const routeMappings = {};

        /**
         * @param {string} moduleName
         * @param {ModuleObj} moduleObj
         * @param {BreadcrumbItem[]} [breadcrumb=[]]
         */
        function traverse(moduleName, moduleObj, breadcrumb = []) {
            // Handle settings routes
            const actualPath = moduleObj.route;

            const currentBreadcrumb = [
                ...breadcrumb,
                {
                    name: moduleName,
                    path: actualPath,
                },
            ];

            // Add mapping if route exists
            if (moduleObj.route) {
                const routePath = moduleObj.route;

                if (moduleObj.moduleId) {
                    routeMappings[routePath] = {
                        ...routeMappings[routePath],
                        [moduleObj.moduleId]: currentBreadcrumb,
                    };
                } else if (!routeMappings[routePath]) {
                    routeMappings[routePath] = currentBreadcrumb;
                }
            }

            // Recursively process sub-modules
            Object.entries(moduleObj).forEach(([key, moduleItem]) => {
                if (key === 'route' || typeof moduleItem !== 'object') {
                    return;
                }

                if (moduleItem.route) {
                    traverse(key, moduleItem, currentBreadcrumb);
                }

                const subModules = Object.entries(moduleItem).filter(([, subModule]) => typeof subModule === 'object');

                const hasValidRoute = subModules.some(([, subModule]) => 'route' in subModule);

                if (hasValidRoute) {
                    subModules.forEach(([subKey, subModule]) => traverse(subKey, subModule, currentBreadcrumb));
                } else {
                    traverse(key, moduleItem, currentBreadcrumb);
                }
            });
        }

        // Process root structure
        Object.keys(routeStructureObj).forEach((moduleName) => {
            traverse(moduleName, routeStructureObj[moduleName]);
        });

        return routeMappings;
    }

    const { routeStructure } = breadcrumbConstantService();

    const routeMappings = createRouteMappings({ ...routeStructure });

    return {
        routeMappings,
    };
};
